import { Component, Input } from '@angular/core';

import { content } from '../../../../content/zci/content';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@vg-constellation/angular-20/icon';

@Component({
    selector: 'zci-triage-mvp-tile',
    templateUrl: './triage-mvp-tile.component.html',
    styleUrls: ['./triage-mvp-tile.component.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent],
})
export class TriageMvpTileComponent {
    @Input() title: string;

    @Input() subTitle: string;

    @Input() description: string;

    @Input() link: string;

    protected readonly environment = environment;

    protected readonly content = content;
}
